import personalAccount from "@/plugins/api/factories/PersonalAccount";

export const state = {
  response: null,
  personalAccountData: null,
  ls: null,
};

export const mutations = {
  SET_RESPONSE(state, response) {
    state.response = response;
  },
  SET_LS(state, ls) {
    state.ls = ls;
  },
  GET_PERSONAL_ACCOUNT_DATA(state, personalAccountData) {
    state.personalAccountData = personalAccountData;
  },
};

export const actions = {
  async setPersonalAccountData({ state, commit }) {
    return await personalAccount.setKhersonEnergoDataForPersonalAccount({ls: state.ls}, (response) => {
        commit("SET_RESPONSE", response);
    });
  },
  async getPersonalAccountData({ commit }) {
    return personalAccount.getKhersonEnergoDataForPersonalAccount((response) => {
      commit("SET_RESPONSE", response);
    });
  },
};
